import React, {useState, useEffect} from "react";
import styled from "styled-components";

export default function DynamicInput(props) {
   const {value} = props;
   const [currentValue, setValue] = useState("");

   useEffect(() => {
      setValue(value);
      return () => {
         setValue("");
      };
   }, [value]);

   if (props.editable) {
      return <Input {...props} value={currentValue} onChange={(e) => setValue(e.target.value)} />;
   }
   return <Input className="readGhost" {...props} readOnly />;
}

export const Input = styled.input`
   border: none;
   outline: none;
   color: rgba(150, 150, 150, 0.8);
   padding: 0;
   font-size: 0.9em;
   border-bottom: 1px solid rgba(150, 150, 150, 0.5);
   box-sizing: border-box;
   width: 230px;
   font-weight: 600;
   background-color: transparent;

   &.error {
      color: crimson:
   }

   &.readGhost {
      border-bottom: transparent;
      cursor: initial;
      padding: 0;
      font-weight: 600;
      width: 200px;

      &.principal {
         font-size: 1.2em;
      }
   }
`;

export const Label = styled.p`
   margin: 0;
   font-size: 0.9em;
   width: 100%;
   font-weight: 300;
   display: inline-block;
   margin-right: 1em;
   user-select: none;
   &.title {
      font-size: 0.9em;
      font-weight: 600;
   }
`;
